module.exports = "<i title=\"{{label}}\" class=\"icon text\">{{value}}</i>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/icon-text/icon-text.component.html
// module id = ../../../../../src/app/modules/ui-base/components/icon-text/icon-text.component.html
// module chunks = main